<!-- ======= Frequently Asked Questions Section ======= -->
<section id="faq" class="faq section-bg" style="margin-top: 125px;">
    <div class="container">

        <div class="section-title">
            <h2>Frequently Asked Questions</h2>
        </div>

        <div class="faq-list">
            <input type="text" [(ngModel)]="search" class="form-control mb-3" style="width: 80%;" placeholder="Search" (keyup)="searchData()"/>
            <ul>
                <li *ngFor="let faq of faqDetails" data-aos="fade-up" data-aos-delay="faq.delay">
                    <i class="{{faq.cssclass}}"></i> <a data-toggle="collapse" href="#{{faq.id}}"
                        class="collapsed">{{faq.heading}} <i class="bx bx-chevron-down icon-show"></i><i
                            class="bx bx-chevron-up icon-close"></i></a>
                    <div id="{{faq.id}}" class="collapse" data-parent=".faq-list">
                        <div [innerHtml]="faq.data"></div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</section>
<!-- End Frequently Asked Questions Section -->